import { render } from "./PictureDisplay2.vue?vue&type=template&id=6bce25f0&scoped=true"
import script from "./PictureDisplay2.vue?vue&type=script&lang=js"
export * from "./PictureDisplay2.vue?vue&type=script&lang=js"

import "./PictureDisplay2.vue?vue&type=style&index=0&id=6bce25f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bce25f0"]])

export default __exports__